module.exports = __webpack_public_path__ + "img/demoLogo.16aac11e.png";